import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8cf75d50&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf75d50')) {
      api.createRecord('8cf75d50', component.options)
    } else {
      api.reload('8cf75d50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8cf75d50&", function () {
      api.rerender('8cf75d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/table/dynamic-table/index.vue"
export default component.exports